module.exports = __webpack_public_path__ + "static/media/portfolio_img3.e7955279.jpg";